// extracted by mini-css-extract-plugin
var _1 = "ra-image-stacker-fade-scale";
var _2 = "ra-image-stacker-static";
var _3 = "ra-image-stacker";
var _4 = "ra-image-stacker-item";
export { _1 as "imageStackerAnimateFadeScaleCls", _2 as "imageStackerAnimateStaticCls", _3 as "imageStackerCls", _4 as "imageStackerItemCls" }
